import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUsers } from "../api-services/register";

export const Register = () => {
    const navigate = useNavigate();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleRegister = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await registerUsers(fullName, email, password);

            if (response.ok) {
                const data = await response.json();
                navigate('/');
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Registration failed');
            }
        } catch (error) {
            setError('An error occurred during registration.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '24px' }}>
            <div style={{ width: '100%', maxWidth: '500px' }}>
                <h1 style={{ fontSize: '28px', fontWeight: '600', color: 'white', textAlign: 'center', marginBottom: '48px' }}>
                    Create your account
                </h1>
                
                {error && <div style={{ color: '#ef4444', marginBottom: '24px', padding: '12px', borderRadius: '6px', backgroundColor: '#fee' }}>{error}</div>}
                
                <form onSubmit={handleRegister}>
                    <input 
                        type="text"
                        placeholder="Full Name" 
                        value={fullName} 
                        onChange={(e) => setFullName(e.target.value)}
                        required
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '12px 16px',
                            fontSize: '16px',
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            marginBottom: '24px',
                            outline: 'none'
                        }}
                    />
                    
                    <input 
                        type="email"
                        placeholder="Email address" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '12px 16px',
                            fontSize: '16px',
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            marginBottom: '24px',
                            outline: 'none'
                        }}
                    />
                    
                    <input 
                        type="password"
                        placeholder="Password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={6}
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '12px 16px',
                            fontSize: '16px',
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            marginBottom: '24px',
                            outline: 'none'
                        }}
                    />
                    
                    <button 
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            height: '48px',
                            fontSize: '16px',
                            fontWeight: '500',
                            backgroundColor: loading ? '#9ca3af' : '#22c55e',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                    >
                        {loading ? 'Creating account...' : 'Register'}
                    </button>
                </form>
                
                <div style={{ textAlign: 'center', marginTop: '32px' }}>
                    <span style={{ color: '#9ca3af' }}>Already have an account? </span>
                    <Link to="/" style={{ color: '#22c55e', textDecoration: 'none' }}>Login</Link>
                </div>
            </div>
        </div>
    )
}
